/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { useMemo } from 'react';

export function useCellEditorVisibleStyle(value: { editing: boolean, width?: number, height?: number }) {
  const { editing, width, height } = value;
  return useMemo(() => {
    if (editing) {
      if (width && height) {
        return {
          width,
          minHeight: height,
        };
      }
      return {};
    }

    return {
      width: 0,
      height: 1,
      border: 'none',
      padding: 0,
      boxShadow: 'none',
      overflow: 'hidden',
    };
  }, [editing, width, height]);
}
